import { IApplicationData } from "./common";
export class RingGroup implements IApplicationData {
  constructor() {
    this.audioId = "";
    this.audioPath = "";
    this.text = "";
    this.content = "";
    this.option = 1;
    this.name = "Ring Group";
    this.sentiment = "";
    this.transition = true;
    this.isRequired = true;
    this.checkFields = false;
    this.attribute = "";
    this.isVariable = false;
    this.ringStrategy = "ringall";
    this.ringingTime = "0";
    this.musiconhold = "";  
    this.members = "";
  }
  name: string;
  members: string;
  ringStrategy: string;
  ringingTime: string;
  musiconhold: string;
  audioPath: string;
  audioId: string;
  text: string;
  content: string;
  option: number;
  transition: boolean;
  sentiment: string;
  isRequired: boolean;
  checkFields: boolean;
  attribute: string;
  isVariable: boolean;
}
